// Shared Google Maps JS API loader (single-load, promise-based).
let loadPromise = null;

export function getGoogleMapsKey() {
  return process.env.REACT_APP_GOOGLE_MAPS_KEY || null;
}

export function loadGoogleMaps() {
  if (typeof window === "undefined") return Promise.reject(new Error("no window"));
  if (window.google && window.google.maps && window.google.maps.places) {
    return Promise.resolve(window.google);
  }
  if (loadPromise) return loadPromise;
  const key = getGoogleMapsKey();
  if (!key) return Promise.reject(new Error("no-api-key"));

  loadPromise = new Promise((resolve, reject) => {
    // If a previous script tag exists, wait for it
    const existing = document.getElementById("gmaps-sdk");
    if (existing) {
      const check = setInterval(() => {
        if (window.google?.maps?.places) {
          clearInterval(check);
          resolve(window.google);
        }
      }, 150);
      setTimeout(() => clearInterval(check), 15000);
      return;
    }
    const s = document.createElement("script");
    s.id = "gmaps-sdk";
    s.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places`;
    s.async = true;
    s.defer = true;
    s.onload = () => {
      if (window.google?.maps?.places) resolve(window.google);
      else reject(new Error("google.maps.places not available"));
    };
    s.onerror = () => reject(new Error("failed to load Google Maps SDK"));
    document.body.appendChild(s);
  });
  return loadPromise;
}

// Golden Gate City (Naples, FL 34116) — user's operating base. Bounds cover
// from downtown Naples (west) to Golden Gate Estates (east) so Places biases
// results in this corridor first. The `NAPLES_CENTER` origin sits inside
// 34116 so Google's location-bias ranking pushes 34116 addresses to the top
// of the suggestion list.
export const NAPLES_BOUNDS = {
  south: 26.08,
  west: -81.83,
  north: 26.28,
  east: -81.63,
};

// Golden Gate City (34116) center — primary location bias for autocomplete.
export const NAPLES_CENTER = { lat: 26.1867, lng: -81.6942 };
